import type React from "react";
import {
  Bot,
  CalendarDays,
  Clock3,
  Phone,
  PhoneMissed,
  Target,
  TrendingUp,
  User,
  UserPlus,
  Users,
} from "lucide-react";
import type {
  DashboardIconName,
  DashboardTone,
} from "@/services/api/dashboard";

export const iconMap: Record<DashboardIconName, React.ElementType> = {
  bot: Bot,
  calendarDays: CalendarDays,
  clock: Clock3,
  phone: Phone,
  phoneMissed: PhoneMissed,
  target: Target,
  trendingUp: TrendingUp,
  user: User,
  userPlus: UserPlus,
  users: Users,
};

export const fallbackIcons = {
  bot: Bot,
  phone: Phone,
  users: Users,
};

export const toneStyles: Record<
  DashboardTone,
  { soft: string; text: string; border: string }
> = {
  blue: {
    soft: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-100",
  },
  green: {
    soft: "bg-green-50",
    text: "text-green-700",
    border: "border-green-100",
  },
  amber: {
    soft: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-100",
  },
  rose: {
    soft: "bg-rose-50",
    text: "text-rose-700",
    border: "border-rose-100",
  },
  purple: {
    soft: "bg-purple-50",
    text: "text-purple-700",
    border: "border-purple-100",
  },
  orange: {
    soft: "bg-orange-50",
    text: "text-orange-700",
    border: "border-orange-100",
  },
};

export const getToneStyle = (tone: DashboardTone) =>
  toneStyles[tone] || toneStyles.blue;
